/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-quotes */
import React from 'react';

import history from 'Util/History';

import './ProductCategoryCard.scss';

export default function ProductCategoryCard({ name, image, url }) {
    return (
    <div
      className='CardCategory'
      onClick={ () => {
          history.push(url);
      } }
    >
      <div className='CardCategory-Card-Img'>
        <img src={ image } alt='Show' />
      </div>
      <h1 className='CardCategory-Card-Name'>{ name }</h1>
    </div>
    );
}
